import client from '../utils/ajax/client';
import {
    ADD_GLOBAL_ERROR, REMOVE_GLOBAL_ERROR, REMOVE_ALL_GLOBAL_ERRORS
} from '../constants/actionconstants';
import * as AuthActions from './auth';


// Inspired by: http://stackoverflow.com/questions/34403269/what-is-the-best-way-to-deal-with-a-fetch-error-in-react-redux
// Also see (for how to override them): http://stackoverflow.com/questions/35417507/how-to-make-a-global-error-handler-in-redux-and-override-it-when-needed

let nextErrorId = 0; // This is to create a handle for each global error which lets you remove a specific error again. All global errors get an id created from this field.

export function addGlobalError(errorTitle, errorMessage, serverErrorId = -1) {
    return (dispatch) => {
        dispatch({
            type: ADD_GLOBAL_ERROR,
            payload: {
                errorId: nextErrorId++,
                errorTitle,
                errorMessage,
                serverErrorId
            }
        });
    }
}

export function removeGlobalError(errorId) {
    return (dispatch) => {
        dispatch({
            type: REMOVE_GLOBAL_ERROR,
            payload: {
                errorId: errorId
            }
        });
    }
}

export function removeAllGlobalErrors() {
    return (dispatch) => {
        dispatch({
            type: REMOVE_ALL_GLOBAL_ERRORS,
            payload: {}
        });
    }
}

export function addGlobalErrorFromResponse(errorTitle, response) {

    return function (dispatch, getState) {
        const statusCode = response.status ? response.status.code : -1;
        const isAuthenticated = getState().auth.isAuthenticated;

        let payload = response.entity;

        if (typeof(payload) == "undefined") payload = {}; // happens...

        if (isAuthenticated && (statusCode == 401 || statusCode == 403) && !payload.userMessage) { // note: if there is a userMessage in the request, the 403 must have been a custom FORBIDDEN error, not related to authentication.
            dispatch(AuthActions.setForceAuthRecheck(true));
            return; // <- This will hide the error causing this from the user - since it is probably him being logged out by the backend that that caused the error, this is a better user-experience (rather than getting 100 random error messages).
                    //    TODO: Should only show one of these errors at a time - not one per ajax call! (Think i fixed this by checking isAuthenticating in requireAuth)
        }

        // Check if payload-JSON corresponds to the standard format of the server-side error function. If so, show the error message from the server. If not, show a generic error message.
        const message = payload.userMessage ? payload.userMessage : "An error has occured - please try again later. (" + statusCode + ")";
        const errorId = payload.errorId ? payload.errorId : -1;

        dispatch(addGlobalError(errorTitle, message, errorId));
    }
}




// WEBPACK FOOTER //
// ./src/client/src/actions/globalerror.js